import { render } from "./savedFilters.vue?vue&type=template&id=1f75d1ce&ts=true"
import script from "./savedFilters.vue?vue&type=script&lang=ts"
export * from "./savedFilters.vue?vue&type=script&lang=ts"

import "./savedFilters.vue?vue&type=style&index=0&id=1f75d1ce&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__